import type {
  CurrentLocation2AutosuggestData,
  PersonalDetails,
} from '../types';

import type { FormValues } from './EditPersonalDetails';

export const getInitialValues = ({
  firstName,
  lastName,
  currentLocation2,
  nationality,
  phoneNumber,
  countryCallingCode,
  defaultCountryCallingCode,
}: PersonalDetails): FormValues => {
  const countryCallingCodeValue =
    countryCallingCode || defaultCountryCallingCode;
  const currentLocation2InitialValue = {
    text: currentLocation2?.description || '',
    value: currentLocation2?.id,
    shortName: currentLocation2?.shortDescription,
    kind: currentLocation2?.kind,
    countryCode: currentLocation2?.countryCode,
  };

  return {
    firstName,
    lastName,
    nationality,
    ...(currentLocation2 && {
      currentLocation2: currentLocation2InitialValue,
    }),
    phoneNumber,
    countryCallingCode: countryCallingCodeValue,
  };
};

export const getStructuredData = ({
  value,
  shortName,
  kind,
  countryCode,
}: CurrentLocation2AutosuggestData) => ({
  value,
  shortName,
  kind,
  countryCode,
});
